export enum MOVIES {
  LATEST = 'Nieuwe films',
  COMING_UP = 'Binnenkort te zien',
  ALL = 'Alle films'
}
